import { useGlobalStore } from '@/frontend/store/GlobalStore';
import { I18n } from '@/i18n/I18n';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { RequirementParams } from '@/backend/access/requirement/types';
import { Plus } from 'lucide-react';
import { EvidenceCategoryModal } from './EvidenceCategoryModal';
import { useRequirementDocumentationStore } from '@/frontend/store/RequirementDocumentationStore';
import { RequirementCategoryType } from '@/backend/access/requirementEvidenceCategory/types';

interface EvidenceCategoryModalProps {
  requirement: RequirementParams;
  type: RequirementCategoryType;
}

export function AddCategoryButton({
  requirement,
  type,
}: EvidenceCategoryModalProps) {
  const [showAddCategory, setShowAddCategory] = useState(false);
  const userClass = useGlobalStore((s) => s.userClass);
  const createCategory = useRequirementDocumentationStore((s) => s.createCategory);

  if(userClass?.getOrgId() !== requirement.propelOrgId) {
    return null;
  }

  return (
    <>
      <Button className="fusa-btn-medium-with-icon" variant="primary" onClick={() => setShowAddCategory(true)}>
          <Plus size={20} />
          {I18n.get('addCategory', { type: I18n.get(type) })}
      </Button>
      {showAddCategory && <EvidenceCategoryModal type={type} onSubmit={(data) => createCategory({ ...data, requirementId: requirement.id, type})} label={I18n.get('addCategory', { type: I18n.get(type) })} onHide={() => setShowAddCategory(false)} />}
    </>
  );
}
